const Logo = () => {
  return (
    <div className="flex items-center flex-nowrap overflow-x-hidden gap-x-2.5 px-6 h-full bg-primary">
      <span className="text-lg font-semibold">GBase</span>
    </div>
  );
};

export default Logo;
